import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash-es";
// import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

// const LETTRAGE_DONE = gql`
//   subscription onEcritureLineLettrageDone($companyId: ID!) {
//     ecritureLineLettrageDone(companyId: $companyId) {
//       date
//     }
//   }
// `;

class BudgetCategoryChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.startCursorArray = [];
  }
  componentDidUpdate() {
    const data = this.props.data && this.props.data.dataForBudgetCategoryChart;

    if (!!!data) {
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      console.log("34 - already in array:", startCursor);
      return;
    }
    this.startCursorArray.push(startCursor);

    if (pageInfo.hasNextPage) {
      this.props.onLoadMore(pageInfo.endCursor, "dataForBudgetCategoryChart");
    }
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];
    if (!this.props.data) return;

    // this.startCursorArray = [];

    // // lettageDoneCreated
    // this.unsubscribeLettageDone = this.props.subscribeToMore({
    //   document: LETTRAGE_DONE,
    //   variables: {
    //     companyId: this.props.companyId
    //   },

    //   updateQuery: (prev, { subscriptionData }) => {
    //     this.props.refetch();

    //     if (!subscriptionData.data) {
    //       return prev;
    //     }
    //     return prev;
    //   }
    // });
    return;
  }

  componentWillUnmount() {
    // this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    //console.log("getDerivedStateFromProps", props);

    if (props && props.data && props.data.dataForBudgetCategoryChart) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.dataForBudgetCategoryChart &&
        state.data.dataForBudgetCategoryChart.edges;

      if (edges) {
        edges = _.orderBy(
          edges,
          [
            "node.category.categoyFamily.name",
            "node.category.name",
            "node.project.name",
            "node.tiers.name",
            "node.year",
            "node.month",
            "node.amount",
            "node.realValue"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.dataForBudgetCategoryChart.edges = edges;

        // // TRANSLATIONS.....
        // _.forEach(edges, o => {
        //   if (o.node && o.node.category && o.node.category.ids !== null) {
        //     // console.log("=>", o.node.category.ids);
        //     o.node.category.name = props.intl.formatMessage({
        //       id: o.node.category.ids
        //     });
        //   }
        // });
      }
    }
  };
  render() {
    // console.log("109 - BudgetChart render", this.props);

    const data = this.state.data && this.state.data.dataForBudgetCategoryChart;

    const edges = data && this.state.data.dataForBudgetCategoryChart.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          edges={edges}
          type="budgets"
          negateValues={false}
          tabs={[
            "budgetCategory",
            "budgetCategoryTiers",
            "budgetCategoryProject"
          ]}
          onRowClick={
            (row, state, rowInfo, column, instance) => { }
            // if (rowInfo.original.invoice)
            //   this.props.history.push(
            //     `/invoices/${rowInfo.original.invoice.id}/edit`
            //   );
            // else if (rowInfo.original.bankTransaction)
            //   this.props.history.push(
            //     `/payments/${rowInfo.original.bankTransaction.id}/affectation`
            //   );
          }
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(BudgetCategoryChart));
